package com.mencanhealth.admin.ui.components

import androidx.compose.runtime.Composable
import com.mencanhealth.admin.ui.Page
import org.jetbrains.compose.web.dom.*

@Composable
fun Sidebar(
    currentPage: Page,
    email: String,
    onNavigate: (Page) -> Unit,
    onSignOut: () -> Unit
) {
    Div({ classes("sidebar") }) {
        Div({ classes("sidebar-header") }) {
            H2 { Text("NutriMX") }
            P({ classes("sidebar-email") }) { Text(email) }
        }
        Nav {
            listOf(
                Page.USERS to "Users",
                Page.CHAT to "Chat",
                Page.APPOINTMENTS to "\uD83D\uDCC5 Citas",
                Page.AVAILABILITY to "\uD83D\uDD50 Horarios",
                Page.ANALYTICS to "Analytics",
                Page.DELETION_REQUESTS to "Eliminaciones"
            ).forEach { (page, label) ->
                A(attrs = {
                    classes("nav-link")
                    if (currentPage == page || (currentPage == Page.USER_DETAIL && page == Page.USERS))
                        classes("nav-link-active")
                    onClick { onNavigate(page) }
                }) { Text(label) }
            }
        }
        Div({ style { property("padding", "12px 20px"); property("border-top", "1px solid rgba(255,255,255,0.1)") } }) {
            P({ style { property("font-size", "11px"); property("color", "rgba(255,255,255,0.4)"); property("margin-bottom", "8px"); property("text-transform", "uppercase"); property("letter-spacing", "1px") } }) { Text("Public Pages") }
            A(href = "/delete-account", attrs = {
                attr("target", "_blank")
                style { property("display", "block"); property("font-size", "13px"); property("color", "rgba(255,255,255,0.6)"); property("padding", "4px 0"); property("cursor", "pointer") }
            }) { Text("Delete Account") }
            A(href = "/privacy-policy", attrs = {
                attr("target", "_blank")
                style { property("display", "block"); property("font-size", "13px"); property("color", "rgba(255,255,255,0.6)"); property("padding", "4px 0"); property("cursor", "pointer") }
            }) { Text("Privacy Policy") }
        }
        Div({ classes("sidebar-footer") }) {
            Button({
                classes("btn-signout")
                onClick { onSignOut() }
            }) { Text("Sign Out") }
        }
    }
}
